import type { ICellRendererParams } from 'ag-grid-community';
import type { Forecast } from '../../schema';

export function HorizonChip(p: ICellRendererParams<Forecast, number>) {
  const days = p.value;
  if (days == null) return null;
  return (
    <span className="inline-flex w-fit shrink-0 items-center self-center rounded-md bg-surface-muted px-1.5 py-0.5 text-[12px] font-mono font-medium text-foreground ring-1 ring-border">
      {days}d
    </span>
  );
}
